import ActionTypes from './../common/ActionTypes';
import Constant from '../common/Constant';
import Strings from '../common/Strings';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/functions');

const moment = require('moment');

let workLogsSnapshot;

function workLogsFetched(workLogs) {
  return {
    type: ActionTypes.PROJECT_DETAILS_WORK_LOGS_FETCHED,
    workLogs,
  };
}

function clearWorkLogs() {
  return {
    type: ActionTypes.PROJECT_DETAILS_WORK_LOGS_CLEAR,
  };
}

function stopSync() {
  if (workLogsSnapshot) {
    workLogsSnapshot();
  }
}

function fetchWorkLogs(project, month) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      let query = firebase
        .firestore()
        .collection('workLogs')
        .where('ownerUid', '==', currentUser.uid)
        .where('projectId', '==', project.id);

      if (month !== Strings.COMMON.lifetime) {
        const startOfMonth = moment(month)
          .startOf('month')
          .format(Constant.DATE_FORMAT);
        const endOfMonth = moment(month)
          .endOf('month')
          .format(Constant.DATE_FORMAT);
        query = query
          .where('date', '>=', startOfMonth)
          .where('date', '<=', endOfMonth);
      }

      stopSync();
      dispatch(clearWorkLogs());

      workLogsSnapshot = query.onSnapshot(
        snapshot => {
          const workLogs = [];

          snapshot.docChanges().forEach(change => {
            const changeType = change.type;
            const workLog = change.doc.data();
            workLog.id = change.doc.id;

            if (changeType === 'added') {
              workLogs.push(workLog);
            }
          });

          dispatch(workLogsFetched(workLogs));
        },
        () => {
          // TODO
        },
      );
    }
  };
}

export const projectDetailsActions = {
  fetchWorkLogs,
  stopSync,
};



// WEBPACK FOOTER //
// ./src/actions/projectDetails.js